var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4 p-4 border-2 border-gray-400"},[_c('header',{staticClass:" border-b-2 border-slate-400 text-4xl font-extrabold"},[_vm._t("title")],2),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }